import type {ReactNode} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Refine} from "@refinedev/core";
import {adminAuthProvider} from "./authProvider";
import {adminDataProvider} from "./dataProvider";
import {adminResources} from "./resources";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {retry: 1, refetchOnWindowFocus: false}
  }
});

export function AdminRefineProvider({children}: {children: ReactNode}) {
  return (
    <QueryClientProvider client={queryClient}>
      <Refine
        dataProvider={adminDataProvider}
        authProvider={adminAuthProvider}
        resources={adminResources}
        options={{
          syncWithLocation: false,
          disableTelemetry: true,
          projectId: "corporatesclub-admin"
        }}
      >
        {children}
      </Refine>
    </QueryClientProvider>
  );
}
